<template lang="pug">
.vue-time-entries-collisions(v-if="!collisionsIsEmpty")
  .table-wrapper.collisions-alert-table
    table.table
      thead
        tr
          th
            .hi.hi-important.hi-16
          th
            span(v-if="check.work_break") This time entry overlaps with work breaks and cannot be saved:

  .table-wrapper
    .scrollable
      table.table
        thead
          tr
            th
            th Work break policy
            th
              .pull-right Duration
            th
        tbody
          tr(
            v-for="collision in collisions"
            :key="collisionText(collision)"
          )
            td
            td
              | {{ collisionText(collision) }}
            td
              .pull-right
                | {{ formatDuration(collision.tracked) }}
            td
</template>
<script>
import { isEmpty, pickBy } from 'lodash-es';

export default {
  name: 'WorkBreakTimeEntriesCollisions',
  props: {
    check: Object,
  },
  computed: {
    collisionsIsEmpty() {
      return isEmpty(this.collisions);
    },
    collisions() {
      return pickBy(this.check.collisions, (value, key) => {
        return value.reasons.includes('work_break');
      });
    },
  },
  methods: {
    collisionText(collision) {
      return collision.project_name;
    },
    formatDuration(duration) {
      return TimeUtils.format_duration(duration);
    },
  },
};
</script>
